<template>
    <div class="guide-card">
        <div class="guide-card-header">
            <div class="guide-card-toolbox-title">{{ title }}</div>

            <slot name="tool"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  title: {
    type: String,
    default: ''
  }
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.guide-card {
    width: 7.5rem;
    margin-top: 0.3rem;
    & > .guide-card-header {
        height: 0.64rem;
        margin: 0 0.32rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 0.28rem;
    }
}
</style>
